import { ISensorGroup } from 'app/business-logic/domain-models/ISensorGroup';
import { MeasurementGroup } from '../../monitoring-service/types';
import { getShortNameForMeasurementGroup } from './getShortNameForMeasurementGroup';

export const convertMeasurementGroupToSensorGroup = ({ description, ...rest }: MeasurementGroup): ISensorGroup => ({
  ...rest,
  description,
  shortName: getShortNameForMeasurementGroup(description),
});
